import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_FEE_TYPES, 
    ADD_NEW_FEE_TYPE, 
    UPDATE_FEE_TYPE, 
    DELETE_FEE_TYPE 
} from "./actionTypes";

import {
    getFeeTypesSuccess,
    getFeeTypesFail,
    addFeeTypeSuccess,
    addFeeTypeFail,
    updateFeeTypeSuccess,
    updateFeeTypeFail,
    deleteFeeTypeSuccess,
    deleteFeeTypeFail,
   
} from "./actions"

import {
    getFeeTypes,
    addNewFeeType,
    updateFeeType,
    deleteFeeType,
   
} from "helpers/fee-types/fee_types_backend_helper";
import { toast } from "react-toastify";

function* fetchFeeTypes() {
    try {
        const response = yield call(getFeeTypes)

        console.log("FEE TYPES: ", response);
        yield put(getFeeTypesSuccess(response))
    } catch (error) {
        yield put(getFeeTypesFail(error))
    }
}

function* onAddNewFeeType({ payload }) {
    try {

        
        const response = yield call(addNewFeeType, payload)

        console.log("RESPONSE:", response);
        yield put(addFeeTypeSuccess(response.feeType))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addFeeTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateFeeType({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateFeeType, payload)
        yield put(updateFeeTypeSuccess(response.feeType))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateFeeTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteFeeType({ payload: data }) {

    try {
        const response = yield call(deleteFeeType, data)
        yield put(deleteFeeTypeSuccess(response.feeTypeId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteFeeTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* feeTypeSaga() {
    yield takeEvery(GET_FEE_TYPES, fetchFeeTypes)
    yield takeEvery(ADD_NEW_FEE_TYPE, onAddNewFeeType)
    yield takeEvery(UPDATE_FEE_TYPE, onUpdateFeeType)
    yield takeEvery(DELETE_FEE_TYPE, onDeleteFeeType)
}

export default feeTypeSaga;